goog.provide("shadow.js.shim.module$ol$source$OSM$default");
shadow.js.shim.module$ol$source$OSM$default = shadow.js.require(290, {}).default;
